import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'emotion-theming';
import { StyleRoot } from 'radium';
import 'antd/dist/antd.min.css';
import { DragDropContext as dragDropContext } from 'react-dnd';
// eslint-disable-next-line import/no-named-default
import { default as multiBackend } from 'react-dnd-multi-backend';
import HTML5toTouch from 'react-dnd-multi-backend/lib/HTML5toTouch';
import themeConfig from '@lyearn-team/theme-config';
import ReportingLibraryInit from 'components/ReportingLibraryInit';

import '../../externalScripts';
import '../../style/externalCSS';
import RelayEnvironmentInit from '../RelayEnvironmentInit';
import CourseSharePreview from '../../admin/views/Creator/CourseSharePreview/CourseSharePreview';
import FeatureFlagInit from '../FeatureFlagInit';
import { LiveClassProvider } from '../LiveClass';
import getParameterByName from '../../helper/LearningSpaceServices/utils/getParameterByName';

import ChannelPreview from './ChannelPreview';
import CertificatePreview from './CertificatePreview';
import BadgePreview from './BadgePreview';
import '../../style/reset.css';
import '../../helper/scorm';
import '../../style/fonts.css';
import '../../style/app.css';
import '../../style/commonStyle.css';
import '../../style/redactor-custom-styles.css';
import '../../helper/windowConstants';

import addGlobalCSS from '../../theme/addGlobalCSS';
import GlobalElementsWrapper from '../GlobalElements/GlobalElementsWrapper';

addGlobalCSS(themeConfig);

const mountNode = document.createElement('div');
document.body.appendChild(mountNode);

window.htmlCardsContent = {};
window.recordedVideoBlobs = {};
window.recordedAudioBlobs = {};
window.textCardContent = {};

class RootContainer extends React.Component {
  contentPreviewType = getParameterByName('type');

  render() {
    const cardId = getParameterByName('cardId');
    const courseId = getParameterByName('courseId');
    const issueId = getParameterByName('issueId');

    return (
      <ThemeProvider theme={themeConfig}>
        <StyleRoot>
          <Router>
            <FeatureFlagInit
              userCheck={
                this.contentPreviewType !== 'certificate' && this.contentPreviewType !== 'badge'
              }
            >
              <RelayEnvironmentInit />
              <GlobalElementsWrapper>
                <ReportingLibraryInit />
                <LiveClassProvider>
                  <React.Fragment>
                    {this.contentPreviewType === 'course' && (
                      <CourseSharePreview params={{ courseId, cardId }} />
                    )}
                    {this.contentPreviewType === 'channelPost' && <ChannelPreview />}
                    {this.contentPreviewType === 'certificate' && (
                      <CertificatePreview params={{ issueId }} />
                    )}
                    {this.contentPreviewType === 'badge' && <BadgePreview issueId={issueId} />}
                  </React.Fragment>
                </LiveClassProvider>
              </GlobalElementsWrapper>
            </FeatureFlagInit>
          </Router>
        </StyleRoot>
      </ThemeProvider>
    );
  }
}

const DraggableRootContainer = dragDropContext(multiBackend(HTML5toTouch))(RootContainer);

ReactDOM.render(<DraggableRootContainer />, mountNode);
